import { render } from "./Media.vue?vue&type=template&id=39c0d0bc&scoped=true"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import "./Media.vue?vue&type=style&index=0&id=39c0d0bc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-39c0d0bc"

export default script